import { render, staticRenderFns } from "./FormPharmacy.vue?vue&type=template&id=5798072c&scoped=true"
import script from "./FormPharmacy.vue?vue&type=script&lang=js"
export * from "./FormPharmacy.vue?vue&type=script&lang=js"
import style0 from "./FormPharmacy.vue?vue&type=style&index=0&id=5798072c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798072c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5798072c')) {
      api.createRecord('5798072c', component.options)
    } else {
      api.reload('5798072c', component.options)
    }
    module.hot.accept("./FormPharmacy.vue?vue&type=template&id=5798072c&scoped=true", function () {
      api.rerender('5798072c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/PharmacyComponent/FormPharmacy.vue"
export default component.exports